<template>
  <div v-cloak>
    <transition appear appear-active-class="fade-enter-active" name="fade">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">
          <router-link to="/config" class="back-link router-link-active"><svg data-v-231527a2="" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-231527a2="" d="M7.41 10.58L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.58Z" fill="#0033A0"></path></svg> назад </router-link>

          <h1>Настройка подсистемы «Паспорт офиса ЦЗН»</h1>

          <table class="config-list-table">
            <thead>
            <tr>
              <th>ID конфигурации</th>
              <th>Период действия</th>
              <th>Дата создания</th>
              <th>Дата изменения</th>
              <th>Статус</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in configs" :key="config.id">
              <td>{{ config.id }}</td>
              <td>{{ config.content.beginDate | dateFormat }} – {{ config.content.endDate | dateFormat }}</td>
              <td>{{ config.createdDate | dateFormat }}</td>
              <td>{{ config.lastModifiedDate | dateFormat }}</td>
              <td v-if="config.active" style="color: darkgreen;">
                Действующая
              </td>
              <td v-else>
                <a href="#" @click.stop="setActive(config.id)">Сделать действующей</a>
              </td>
              <td>
                <div class="edit">
                  <router-link :to="'/passportczn/info/' + config.id">
                    <v-icon class="icon-item icon-briefcase-eye-outline"></v-icon>
                  </router-link>
                </div>
                <router-link :to="'/config/passportCZNConfigEdit/' + config.id">
                  <div class="edit">
                    <v-icon class="icon-item icon-note-edit-outline"></v-icon>
                  </div>
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="save-buttons">
            <v-btn color="primary" @click="$router.push('/config/passportCZNConfigEdit/')">Создать конфигурацию</v-btn>
          </div>

        </div>
        <div v-if="errorText != null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
    <loader-dialog :show="loading" msg="Загрузка"></loader-dialog>
  </div>
</template>

<script>
import LoaderDialog from "@/components/elements/LoaderDialog.vue";
import {getDomainConfigs, setDomainConfigStatus} from "@/modules/api.configs";

export default {
  name: "PassportCznConfig",
  components: {LoaderDialog},
  data() {
    return {
      configs: [],
      domain: 'passport_czn',
      apiLoaded: false,
      errorText: null,
      loading: false,
    };
  },
  methods: {
    async loadConfigs() {
      this.loading = true
      let req = await getDomainConfigs(this.domain)
      if (req.ok) {
        this.configs = req.payload
        this.sortConfigsByCreatedDate()
        this.apiLoaded = true
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
      this.loading = false
    },
    async setActive(configId) {
      this.loading = true
      let req = await setDomainConfigStatus(this.domain, configId, true, true)
      if (req.ok) {
        await this.loadConfigs()
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
      this.loading = false
    },
    sortConfigsByCreatedDate() {
      this.configs.sort((a, b) => (a.createdDate < b.createdDate) ? 1 : -1)
    },
  },
  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },
  async beforeMount() {
    await this.loadConfigs()
  }
};
</script>

<style lang="scss">
@import "../../../styles/main.scss";
</style>

<style lang="scss" scoped>
</style>
